/** B2C signup user-flow authority (passed to loginRedirect, not a separate PCA). */
export const signupAuthority = process.env.REACT_APP_AZURE_AD_AUTHORITY_SIGNUP;
